import {ErrorHandler, Inject, Injectable} from '@angular/core';
import {RollbarService} from '../config/rollbar';
import * as Rollbar from 'rollbar';
import {environment} from '../../environments/environment';

@Injectable()
export class RollbarErrorHandler implements ErrorHandler {
  constructor(@Inject(RollbarService) private rollbar: Rollbar) {
  }

  public handleError(err: any): void {
    if (environment.name === 'production' || environment.name === 'acceptance') {
      this.rollbar.error(err.originalError || err);
    } else {
      console.error(err);
    }
  }
}
